import React, { useEffect, useState } from 'react'
import { FaPlusCircle, FaRegTimesCircle } from 'react-icons/fa'
import { IconButton } from '@material-ui/core'
import { Switch, Route } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { useQuery } from '@apollo/client'

import Materials from './Displays/Materials'
import BaseBin from '../BaseBin'
import styles from './materials.module.scss'
import CreateCatalogue from './Forms/CreateCatalogue'
import Loading from 'components/Global/Loading'
import CreateSwatch from './Forms/CreateSwatch'
import { catalogueType } from './materialTypes'
import { Q_MATERIAL_CATALOGUE } from 'graphql/query'
import Swatches from './Displays/Swatch/Swatches'
import NoContents from 'components/Global/NoContents'

const MaterialsBin = () => {
  const { refetch } = useQuery(Q_MATERIAL_CATALOGUE)

  const [create, setCreate] = useState<number | boolean>(false)
  const [catalogues, setCatalogues] = useState<catalogueType[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [noContents, setNoContents] = React.useState<boolean>(false)

  let history = useHistory()

  const update = () => {
    refetch() &&
      refetch()
        .then(res => {
          setCatalogues(res.data.rMaterialCatalogue)
          res.data.rMaterialCatalogue.length == 0
            ? setNoContents(true)
            : setNoContents(false)

          setLoading(false)
        })
        .catch(err => {
          console.error(err)
          setNoContents(true)
        })
  }

  React.useEffect(() => {
    if (create) setCreate(history.location.pathname.split('/').length - 2)
  })

  React.useEffect(() => {
    update()
  }, [refetch])

  const close = () => {
    setCreate(false)
    setLoading(true)
    update()
  }

  const Forms = () => {
    switch (create) {
      case 1: {
        return <CreateCatalogue close={close} />
      }
      case 2: {
        return <CreateSwatch close={close} />
      }
      default: {
        return null
      }
    }
  }

  return (
    <BaseBin
      title="Materials"
      errors={null}
      actions={[
        <IconButton
          color="primary"
          onClick={() =>
            setCreate(
              typeof create === 'number'
                ? false
                : history.location.pathname.split('/').length - 2
            )
          }
          className={styles.createButton}
        >
          {!create ? <FaPlusCircle /> : <FaRegTimesCircle />}
        </IconButton>,
      ]}
    >
      {loading ? (
        <Loading />
      ) : !create ? (
        <Switch>
          <Route
            exact
            path="/dashboard/materials/:swatch"
            children={<Swatches />}
          />

          <Route
            path="/dashboard/materials"
            children={
              noContents ? <NoContents /> : <Materials data={catalogues} />
            }
          />
        </Switch>
      ) : (
        <Forms />
      )}
    </BaseBin>
  )
}

export default MaterialsBin
